import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import PlotDetailPane from "../plot/plot_detail_pane";
import {ProjectsService} from "../../../service/v1/projects";
import CreateService from "../../../service/create";
import CollectService from "../../../service/v1/collect";
import baseUrl from "../../../service/baseURL";

export default class CCRORegisteredDataPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            search:'',
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 100,
            newPageSize: 100,
            village_id:0,
            villages:[],
        }
        this.loadData = this.loadData.bind(this)
        this.searchData = this.searchData.bind(this)
        this.loadLocalities = this.loadLocalities.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
    }

    componentDidMount() {
        this.loadData()
        this.loadLocalities()
    }

     handleChanges=(e)=>{
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    loadLocalities() {
        try{
            Wait.show('Loading Villages...')
            ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                try {
                    let data = r.data.results

                    console.log(data)
                    this.setState({
                        villages:data,
                        village_id:data[0].id
                    })

                    setTimeout(()=>this.loadData(), 500)
                }catch (e) {
                    console.log(e)
                }


            })
        }catch (e) {
            console.log(e)
        }

    }


    searchData() {
        try {
            Wait.show('Searching....')
            ReadService.searchCCRODataByStage(this.props.project.id,this.state.search.replaceAll('/','_'),this.state.village_id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
            })
        }catch (e) {
            console.log(e)
        }
    }


    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            height: '100vh',
            background: '#f6f8fa',
            fontFamily,
            display: 'flex',
            overflow: 'hidden'
        };
        
        const sidebar = {
            width: '280px',
            background: '#fff',
            borderRight: '1px solid #e0e7ef',
            height: '100vh',
            overflowY: 'auto',
            boxShadow: '2px 0 8px rgba(0,0,0,0.1)'
        };
        
        const sidebarHeader = {
            padding: '20px',
            borderBottom: '1px solid #e0e7ef',
            background: 'linear-gradient(135deg, #395d9a 0%, #2bbbad 100%)',
            color: '#fff'
        };
        
        const sidebarTitle = {
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '4px'
        };
        
        const sidebarSubtitle = {
            fontSize: '12px',
            opacity: 0.8
        };
        
        const statsCard = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '20px',
            margin: '16px',
            border: '1px solid rgba(57,93,154,0.05)',
            textAlign: 'center'
        };
        
        const statsNumber = {
            fontSize: '32px',
            fontWeight: '700',
            color: '#395d9a',
            marginBottom: '8px'
        };
        
        const statsLabel = {
            fontSize: '14px',
            color: '#666',
            fontWeight: '500'
        };
        
        const mainContent = {
            flex: 1,
            padding: '0 24px 24px 24px',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        };
        
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#395d9a',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px',
            flexShrink: 0
        };
        
        const searchInput = {
            padding: '10px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: 14,
            fontFamily,
            width: '200px',
            transition: 'border-color 0.2s, box-shadow 0.2s'
        };
        
        const select = {
            padding: '10px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: 14,
            fontFamily,
            background: '#fff',
            minWidth: '150px'
        };
        
        const btn = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const btnSecondary = {
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const btnSuccess = {
            background: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const dataCard = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(57,93,154,0.12), 0 2px 4px rgba(57,93,154,0.08)',
            padding: '16px',
            fontFamily,
            marginBottom: '16px',
            border: '1px solid rgba(57,93,154,0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: 0
        };
        
        const cardHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#395d9a',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            paddingBottom: '8px',
            borderBottom: '2px solid #f0f0f0',
            flexShrink: 0
        };
        
        const tableContainer = {
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: 0,
            border: '1px solid #e0e7ef',
            flex: 1,
            maxHeight: 'calc(100vh - 320px)',
            minHeight: 0
        };
        
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 14,
            border: '1px solid #e0e7ef'
        };
        
        const tableHeader = {
            background: '#f8f9fa',
            padding: '8px 12px',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 600,
            color: '#395d9a',
            borderBottom: '2px solid #e0e7ef',
            borderRight: '1px solid #e0e7ef',
            borderLeft: '1px solid #e0e7ef'
        };
        
        const tableCell = {
            padding: '8px 12px',
            fontSize: 14,
            color: '#333',
            borderBottom: '1px solid #e0e7ef',
            borderRight: '1px solid #e0e7ef',
            borderLeft: '1px solid #e0e7ef'
        };
        
        const paginationContainer = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            padding: '20px',
            background: '#f8f9fa',
            borderTop: '1px solid #e0e7ef',
            flexShrink: 0
        };
        
        const paginationBtn = {
            padding: '8px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            background: '#fff',
            color: '#333',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 500,
            transition: 'all 0.2s',
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
        };
        
        const paginationInfo = {
            fontSize: 14,
            fontWeight: 600,
            color: '#395d9a',
            minWidth: '80px',
            textAlign: 'center'
        };

        return (
            <div style={container}>
                <div style={sidebar}>
                    <div style={sidebarHeader}>
                        <div style={sidebarTitle}>
                            <span className={'fa fa-check-circle'} style={{marginRight: 8}}/>
                        Registered Data
                        </div>
                        <div style={sidebarSubtitle}>
                            {this.state.count || 0} records found
                        </div>
                    </div>
                    
                    <div style={statsCard}>
                        <div style={statsNumber}>
                            {this.state.count || 0}
                        </div>
                        <div style={statsLabel}>
                            Total Registered Records
                        </div>
                    </div>
                    
                    <div style={{padding: '16px', fontSize: '12px', color: '#666', textAlign: 'center'}}>
                        <span className={'fa fa-history'} style={{marginRight: 6}}/>
                        Updated 28 Minutes Ago
                </div>
                </div>

                <div style={mainContent}>
                    <div style={header}>
                        <span>
                            <span className={'fa fa-check-circle'} style={{marginRight: 12}}/>
                        </span>
                        
                        <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                            <input 
                                name={'search'} 
                                onChange={this.handleChanges}
                                style={searchInput}
                                placeholder={'Search...'}
                            />
                            
                            <button style={btnSecondary} onClick={() => this.searchData()}>
                            <span className={'fa fa-search'}/>Search
                        </button>

                            <select 
                                name={'village'} 
                                style={select}
                                onChange={this.handleChanges}
                            >
                                <option value={undefined}>- Choose Village -</option>
                                {this.state.villages.map((d, i) => (
                                    <option value={d.id} key={i}>{d.name}</option>
                                ))}
                            </select>
                            
                            <button style={btnSecondary} onClick={() => this.loadData(0)}>
                        <span className={'fa fa-refresh'}/>Refresh
                    </button>

                            <button style={{...btnSecondary, background: 'linear-gradient(90deg, #fd7e14 0%, #e8590c 100%)', color: 'white'}} onClick={() => this.previewParcels()}>
                                <span className={'fa fa-eye'}/>View
                            </button>

                            <button style={btnSuccess} onClick={() => this.downloadExcel()}>
                    <span className={'fa fa-download'}/>Download Excel
                </button>

                            <button style={btn} onClick={() => this.loadData(0)}>
                                <span className={'fa fa-download'}/>Download .SHP
                            </button>
                        </div>
                    </div>
                    
                    <div style={dataCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-table'} style={{color: '#395d9a'}}/>
                            Registered Records
                        </div>
                        
                        <div style={tableContainer}>
                            <table style={table}>
                        <thead>
                        <tr>
                                        <th style={tableHeader}>#</th>
                                        <th style={tableHeader}>Claimed Data</th>
                                        <th style={tableHeader}>Claim Number</th>
                                        <th style={tableHeader}>Uka Number</th>
                                        <th style={tableHeader}>Registration Number</th>
                                        <th style={tableHeader}>Village</th>
                                        <th style={tableHeader}>Hamlet</th>
                        </tr>
                        </thead>
                        <tbody>
                                    {this.state.data.map((d, i) => (
                                        <tr key={i} style={{cursor: 'pointer', verticalAlign: 'top'}}
                                            title={d.description}
                                            onClick={() => PopDetail.show(d.claim_no,
                                                <PlotDetailPane screen_code={this.props.screen_code}
                                                                taskId={this.props.taskId} parcel={d}
                                                                key={new Date().getMilliseconds()}/>)}>
                                            <td style={tableCell}>
                                                {this.state.next === null
                                        ? this.state.previous !== null
                                            ? this.state.previous.split('=').length > 1
                                                ? (this.state.previous.split('=')[1] * this.state.pageSize) + i + 1
                                                : this.state.pageSize + i + 1
                                            : 0 + i + 1
                                        : (this.state.next.split('=')[1] - 1) > 1
                                            ? (this.state.next.split('=')[1] - 2) * this.state.pageSize + i + 1
                                            : i + 1
                                    }
                                </td>
                                            <td style={tableCell}>{d.datetime}</td>
                                            <td style={tableCell}>
                                                <b style={{color: '#395d9a'}}>{d.claim_no}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#395d9a'}}>{d.uka_namba}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#395d9a'}}>{d.registration_no}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#395d9a'}}>{d.locality_info.village}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#395d9a'}}>{d.locality_info.hamlet}</b>
                                </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                                                <div style={paginationContainer}>
                            <button 
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.newPageSize - this.state.pageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }} 
                                style={paginationBtn}
                                disabled={this.state.previous === null}
                            >
                                <span className={'fa fa-chevron-left'}/> Previous
                            </button>
                            
                            <span style={paginationInfo}>
                                {this.state.totalPages === 0 ? 0 : (this.state.newPageSize) / this.state.pageSize} / {this.state.totalPages}
                            </span>
                            
                            <button 
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.pageSize + this.state.newPageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }} 
                                style={paginationBtn}
                                disabled={this.state.next === null}
                            >
                                Next <span className={'fa fa-chevron-right'}/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    loadData(stage=0) {
        try {
            Wait.show('Fetching Registered Data....')
            ReadService.fetchCCRODataByStage(this.props.project.id,this.props.stage).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
            })
        }catch (e) {
        

        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        data: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous,
                        count: r.data.count
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    downloadExcel(){
        try {
            Wait.show('Generating Excel....')
            let village_id = this.state.village_id
            CreateService.downloadParcelExcel(village_id, this.props.stage).then(response => {
                Wait.dismiss()
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.props.stage + '.xlsx'); // Specify the filename

                // Simulate a click on the link to trigger the file download
                // simulate a clicl on the link to trigger the file download
                document.body.appendChild(link);
                link.click();

                // Clean up the temporary objects
                link.remove();
                window.URL.revokeObjectURL(url);

            })
        }catch (e) {
            console.log(e)
        }
    }

    previewParcels() {
        try {
            let village_id = parseInt(this.state.village_id)

            if (village_id === undefined || village_id === 0) {
                alert('Please select a village first')
                return
            }

            // Get the stage from the props
            let stage = this.props.stage || '';

            Wait.show('Loading parcels preview...')
            
            // Construct the direct URL for the parcels map
            const parcelsMapUrl = `${baseUrl()}/collect/ccro/parcels/map?village_id=${village_id}&stage=${stage}`;
            
            // Open the URL directly in a new tab
            const newWindow = window.open(parcelsMapUrl, '_blank');
            
            if (!newWindow) {
                alert('Please allow popups for this site to view the parcels preview');
            }
            
            Wait.dismiss()
            
        } catch (e) {
            Wait.dismiss()
            console.error('Error in previewParcels:', e);
            alert('Error loading parcels preview. Please try again.');
        }
    }
}
